/**
 * WooCommerce checkout.
 * 
 * @since 1.0.1
 * @author Fahri Rusliyadi <fahri.rusliyadi@gmail.com>
 */

"use strict";

import $ from 'jquery';

/**
 * Display loader on submit button when placing order.
 */
function showLoaderWhenPlacingOrder() {
    const $loader = $('<span class="sr-loader-wrapper"><span class="sr-loader-icon"></span></span>')
    
    $('form.checkout').on('checkout_place_order', function() {
        const $button = $(this).find('[type="submit"]')
        $button.append($loader)
    })

    $(document).on('checkout_error', function() {
        $loader.detach()
    })
}
    
export default function() {
    showLoaderWhenPlacingOrder()
}
